import CHash from 'color-hash';

const CH = new CHash({ hash: 'bkdr', saturation: [0.65, 0.35, 0.5], lightness: [0.65, 0.35, 0.5] });

const COLOR_HASHES = {};

export function hash(id: string) {
	var color = COLOR_HASHES[id];
	if (color == null) {
		color = COLOR_HASHES[id] = CH.hex(id);
	}
	return color;
}

export const ColorHash = { hash };
